export type NatalChartBlockValuesPayload = {
  block_names: string[];
  timezone: string;
  date_time_birth?: string;
  place_birth?: string;
  lat?: number;
  lng?: number;
  gender?: string;
  partner_sign?: string;
  partner_gender?: string;
  archetype?: string;
  zodiac?: string;
};

export type NatalChartBlockValue = {
  blockName: string;
  id: string;
  summary: string;
};

export const NatalChartBlockNames = [
  'personalPlanets_sun_description',
  'personalPlanets_moon_description',
  'keyRevelations_sun_ascendant_description',
  'personalPlanets_venus_description',
  'houses_seventh_description',
  'personalPlanets_mars_description',
  'houses_fifth_description',
  'personalPlanets_mercury_description',
  'houses_tenth_description',
  'houses_second_description',
];
